export interface SortingModel {
  selected: string,
  options: SortingOption[]
}

export interface SortingOption {
  label: string,
  value: SortingOptionsValuesEnum
}

export enum SortingOptionsValuesEnum {
  DEFAULT = '',
  NEWEST = 'created_at_DESC',
  NAME_ASC = 'name_ASC',
  NAME_DESC = 'name_DESC',
  PRICE_ASC = 'price_ASC',
  PRICE_DESC = 'price_DESC',
}

export const sortingOptions: SortingOption[] = [
  {
    label: 'Mặc định',
    value: SortingOptionsValuesEnum.DEFAULT,
  },
  {
    label: 'Mới nhất',
    value: SortingOptionsValuesEnum.NEWEST,
  },
  {
    label: 'Name: Từ A-Z',
    value: SortingOptionsValuesEnum.NAME_ASC,
  },
  {
    label: 'Name: Từ Z-A',
    value: SortingOptionsValuesEnum.NAME_DESC,
  },
  {
    label: 'Giá: thấp đến cao',
    value: SortingOptionsValuesEnum.PRICE_ASC,
  },
  {
    label: 'Giá: cao đến thấp',
    value: SortingOptionsValuesEnum.PRICE_DESC,
  },
];
